import React, { Component } from "react"
import {validate} from "./validation";
import "../../style/forms.scss";
import { ValidationMessage } from "./validation-message";
import PropTypes from "prop-types";

export default class Radio extends Component{
    constructor(props){
        super(props);
        let defaultValue = null;
        for(let i=0;i<props.options.length;i++){
            if(props.options[i].default === true){
                defaultValue = props.options[i].key;
                break;
            }
        }
        this.state = {
            value: ((props.value == null || props.value === "") ? defaultValue : props.value),
            validationResult: {isValid:true,rules:[]}
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(this.props.value !== nextProps.value){
            this.setState({value: nextProps.value})
        }
        if(typeof(nextProps.validation) !== "undefined" &&
            typeof(nextProps.validation.validationResult) !== "undefined" &&
            nextProps.validation.validationResult.isValid !== this.state.validationResult.isValid){
            this.setState({validationResult: nextProps.validation.validationResult})
        }
    }
    handleChange(event){
        let validationResult = {isValid:true,rules:[]};
        let value = event.target.value;
        this.setState({value: value})
        if(typeof(this.props.onChange) === "function"){
            this.props.onChange({field: this.props.name, value: value, validationResult:validationResult});
        }
    }
    handleBlur(event){
        let validationResult = {isValid:true,rules:[]};
        let value = event.target.value;

        if(typeof(this.props.validation) !== "undefined"){
            let validationRuleResults = validate(this.props.validation,value);
            for(let ruleIndex in validationRuleResults){
                validationResult.isValid = validationResult.isValid && validationRuleResults[ruleIndex].isValid
            }
            validationResult.rules = validationRuleResults;
        }
        this.setState({value: value, validationResult: validationResult})
        if(typeof(this.props.onBlur) === "function"){
            this.props.onBlur({field: this.props.name, value: value, validationResult:validationResult});
        }
    }
    render(){
        let requiredClass = (this.props.validation && this.props.validation.isRequired) ? " required ":""
        let groupTitleWithRequired = this.props.groupTitle + ((this.props.validation && this.props.validation.required) ? "*":"")
        const groupTitle = this.props.groupTitle ? <label className="form-radio-group-label">{groupTitleWithRequired}</label> : "";
        return (
            <div className={"form-field-group " + (!this.state.validationResult.isValid ? "validation-invalid ":"") + (this.props.readOnly === true ? " field-disabled ":"") + this.props.className}>
                {groupTitle}
                <ValidationMessage validationResult={this.state.validationResult}/>
                {this.props.options.map(item => {
                    return <div key={item.key}><label  className="form-radio-label">
                        <input type="radio"
                               value={item.key}
                               checked={item.key === this.state.value || ((this.state.value == null || this.state.value === "") && item.default === true)}
                               onChange={this.handleChange}
                               disabled={this.props.readOnly === true || item.disabled === true}
                        />
                        {item.label ? item.label : item.key}<span className={"new-radio-btn " + ((this.props.readOnly === true || item.disabled === true)?"disabled":"")}></span></label>
                        {item.afterElement ? item.afterElement : null}
                    </div>
                })}

            </div>
        )
    }
}
Radio.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    afterElement: PropTypes.element
}



// WEBPACK FOOTER //
// ./src/common/components/forms/radio.jsx